/**
 * One key family for everything that reads Master Barang, so a write, an
 * import or a colleague's `master_barang_changed` refreshes the page's table
 * and importer picker alike. Its own module so the realtime bus can use it
 * without importing the HTTP layer.
 */
export const masterBarangKeys = {
  all: ['master', 'barangs'] as const,
  /** Without a PPJK: the prefix of every PPJK's importer list, for invalidation. */
  importers: (ppjkNpwp?: string) =>
    ppjkNpwp ? (['master', 'barangs', 'importers', ppjkNpwp] as const) : (['master', 'barangs', 'importers'] as const),
  list: (params: Record<string, unknown>) => ['master', 'barangs', 'list', params] as const,
  events: (params: Record<string, unknown>) => ['master', 'barangs', 'events', params] as const,
};
